/**
 * 移动端性能优化工具函数
 */

// 防抖函数
export const debounce = (func, wait) => {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

// 节流函数
export const throttle = (func, limit) => {
  let inThrottle
  return function () {
    const args = arguments
    const context = this
    if (!inThrottle) {
      func.apply(context, args)
      inThrottle = true
      setTimeout(() => inThrottle = false, limit)
    }
  }
}

// 移动端触摸事件优化
export const createTouchHandler = (callback, options = {}) => {
  const {
    preventDefault = true,
    stopPropagation = true,
    throttleDelay = 100
  } = options

  let touchStartTime = 0
  let touchStartY = 0
  let touchStartX = 0
  let lastCallbackTime = 0

  const handleTouchStart = (event) => {
    if (preventDefault) event.preventDefault()
    if (stopPropagation) event.stopPropagation()

    touchStartTime = Date.now()
    touchStartY = event.touches[0].clientY
    touchStartX = event.touches[0].clientX

  }

  const handleTouchEnd = (event) => {
    if (preventDefault) event.preventDefault()
    if (stopPropagation) event.stopPropagation()

    const touchEndTime = Date.now()
    const touchDuration = touchEndTime - touchStartTime
    const currentTime = Date.now()
    console.log('touchDuration', touchDuration)

    // 恢复按钮状态
    if (event.target) {
      event.target.style.transform = ''
    }

    // 检查是否为有效点击（时间短且移动距离小）
    if (touchDuration < 300) {
      const touchEndY = event.changedTouches[0].clientY
      const touchEndX = event.changedTouches[0].clientX
      const deltaY = Math.abs(touchEndY - touchStartY)
      const deltaX = Math.abs(touchEndX - touchStartX)

      if (deltaY < 10 && deltaX < 10) {
        // 使用 throttleDelay 进行节流控制
        if (currentTime - lastCallbackTime >= throttleDelay) {
          callback(event)
          lastCallbackTime = currentTime
        }
      }
    }
  }

  return {
    handleTouchStart,
    handleTouchEnd
  }
}

// 移动端滚动优化
export const optimizeScroll = (element) => {

  if (!element) return

  let ticking = false

  const handleScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        console.log('handleScroll')
        // 在这里可以添加滚动时的优化逻辑
        ticking = false
      })
      ticking = true
    }
  }

  element.addEventListener('scroll', handleScroll, { passive: true })

  return () => {
    element.removeEventListener('scroll', handleScroll)
  }
}

// 移动端点击优化
export const optimizeClick = (element, callback) => {
  if (!element) return

  const touchHandler = createTouchHandler(callback, {
    preventDefault: false,
    stopPropagation: true
  })

  element.addEventListener('touchstart', touchHandler.handleTouchStart, { passive: false })
  element.addEventListener('touchend', touchHandler.handleTouchEnd, { passive: false })

  return () => {
    element.removeEventListener('touchstart', touchHandler.handleTouchStart)
    element.removeEventListener('touchend', touchHandler.handleTouchEnd)
  }
}

// 防止移动端双击缩放
export const preventDoubleTapZoom = () => {
  let lastTouchEnd = 0

  document.addEventListener('touchend', (event) => {
    const now = (new Date()).getTime()
    if (now - lastTouchEnd <= 300) {
      event.preventDefault()
    }
    lastTouchEnd = now
  }, false)
}

// 移动端性能监控
export const createPerformanceMonitor = () => {
  const metrics = {
    touchStartTime: 0,
    touchEndTime: 0,
    renderTime: 0
  }

  const startTouch = () => {
    metrics.touchStartTime = performance.now()
  }

  const endTouch = () => {
    metrics.touchEndTime = performance.now()
    const touchDuration = metrics.touchEndTime - metrics.touchStartTime

    if (touchDuration > 100) {
      console.warn(`Touch response time: ${touchDuration.toFixed(2)}ms`)
    }
  }

  return {
    startTouch,
    endTouch,
    metrics
  }
}
